import  { useEffect, useMemo, useState, useCallback, useRef } from "react";
import { changeMode, changeModeForField, checkEditEnabled, fieldTruePermission, prepareDefaultValues, prepareInitialConfig } from "../../../utils/formHelper";
import { useForm } from "react-hook-form";
import { useParams, useNavigate } from "react-router-dom";
import { STAUTES } from "../../../utils/constant";
import { Grid } from "@mui/material";
import { ADD_RAP_JOB_TITLE, UPDATE_RAP_JOB_TITLE, GET_RAP_JOB_TITLE } from "../../../utils/services/apiPath";
import { getApi, postApi, putApi } from "../../../utils/services";
import { errorToast, successToast } from "../../../utils/toastHelper";
import { useTheme } from "../../ContextStore/ThemeContext";
import { useDispatch, useSelector } from "react-redux";
import { handleLogout, userSelector } from "../../store/features/auth/authSlice";
import logo from "../../Assets/Icons/logo.png";
import logoWhite from "../../Assets/Icons/logo-white.png";
import menuopen from "../../Assets/Icons/menu-open.png";
import menuclose from "../../Assets/Icons/menu-close.png";
import NotificationIcon from "../../Assets/IconComponents/Notification";
import { headerMenus } from "../../../utils/MenusConfig";
import HelpMenu from "../../Components/Header/HelpMenu";
import {ProTextInput, SettingFormsLayout, Layout} from "@proscore-ai/proscore-ui-library";

const JobProfileFormConfing = {
  jobTitle: {
    label: "Labor Classification Title",
    rules: { required: "Labor Classification Title is Required!" }
  },
  oneTCode: {
    label: "ONET Code",
    rules: { required: "ONET Code is Required!" }
  }
};

export default function AddJobTitles() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isAddMode = useMemo(() => id === "add", [id]);
  const [status, setStatus] = useState(STAUTES.IDLE);
  const [formConfig, setFormConfig] = useState(prepareInitialConfig(JobProfileFormConfing, isAddMode ? "edit" : "read"));
  const { handleSubmit, control, setValue } = useForm({ defaultValues: prepareDefaultValues(JobProfileFormConfing) });
  const [jobTitleData, setJobTitleData] = useState({});
  const [isSaving, setIsSaving] = useState(false);
  const { theme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);
  const [popOverOpen, setPopOverOpen] = useState(false);
  const ref = useRef(null);
  const userData = useSelector(userSelector);
  const dispatch = useDispatch();

  const handleTabClick = tab => {
    navigate(`${tab.to}`);
  };
  const handleMenuOpen = () => setMenuOpen(!menuOpen);

  const onLogout = () => {
    dispatch(handleLogout());
  };

  const manageAccount = () => {
    setPopOverOpen(false);
  };

  const handleHome = () => {
    navigate("/clients");
  };

  const isEditModeOn = useMemo(() => checkEditEnabled(isAddMode, formConfig), [isAddMode, formConfig]);

  const backAction = () => navigate("/job-titles");
  const onEdit = () => setFormConfig(changeMode("edit"));
  const onCancel = () => {
    if (isAddMode) backAction();
    else setFormConfig(changeMode());
  };

  const getDetailById = useCallback(async () => {
    setStatus(STAUTES.LOADING);
    const { error, ...data } = await getApi(`${GET_RAP_JOB_TITLE}/${id}`);
    setStatus(STAUTES.IDLE);
    if (error) return errorToast(error);
    setJobTitleData(data);
    Object.keys(JobProfileFormConfing).forEach(field => setValue(field, data[field]));
  }, [setValue, id]);

  const handleReadValueClick = name => setFormConfig(changeModeForField(name, "edit"));


  const onSubmit = async data => {
    if (isSaving) return; 
    setIsSaving(true);
    setStatus(STAUTES.LOADING);
    const payload = { ...jobTitleData, ...data };
    const method = isAddMode ? postApi : putApi;
    const { error } = await method(isAddMode ? ADD_RAP_JOB_TITLE : UPDATE_RAP_JOB_TITLE, payload);
    setIsSaving(false); 
    setStatus(STAUTES.IDLE);
    if (error) return errorToast(error);
    successToast(`Labor Classification Title ${isAddMode ? "added" : "updated"} successfully.`);
    backAction();
  };

  useEffect(() => {
    if (!isAddMode) getDetailById(id);
  }, [id, isAddMode, getDetailById]);

  const defaultFormProps = { control, formValues: jobTitleData, isAddMode, handleReadValueClick };

  return (
    <Layout status={status}
      theme={theme}
      user={{
        userName: userData?.userName,
        email: userData?.email,
        avatar: userData?.avatar
      }}
      onLogout={onLogout}
      onTabClick={handleTabClick}
      onLogoClick={handleHome}
      logo={logo}
      logoWhite={logoWhite}
      menuOpenIcon={menuopen}
      menuCloseIcon={menuclose}
      menuTabs={headerMenus}
      NotificationIcon={NotificationIcon}
      HelpComponent={HelpMenu}
    >
      <SettingFormsLayout
        backAction={backAction}
        title={`${isAddMode ? "Add" : "Edit"} Labor Classification Title`}
        backLabel="Go Back to Labor Classification Titles"
        beingEdited={isEditModeOn}
        onEdit={onEdit}
        onCancel={onCancel}
        onSave={handleSubmit(onSubmit)}
        isSaving={isSaving}
      >
        <Grid container spacing={2}>
          <ProTextInput {...defaultFormProps} {...formConfig.jobTitle} permission={fieldTruePermission}/>
          <ProTextInput {...defaultFormProps} {...formConfig.oneTCode} permission={fieldTruePermission}/>
        </Grid>
      </SettingFormsLayout>
    </Layout>
  );
}
